import {apiBase} from 'api/base.js';

class DepositFarmRelationAPI {
  index() {
    return apiBase.get('/admin/deposit_farm_relation');
  }
}

export const depositFarmRelationAPI = new DepositFarmRelationAPI();
